import React, {
    useRef,
    useEffect,
    useState
} from "react";

import logo from "../../../assets/images/logo/dodeal-white.png";
import WebMobileAppForm from "../../../components/Forms/WebMobileAppForm";
import { useStateContext } from "../../../context/ContextProvider";
import LanguageNavigate from "../../../components/Language/LanguageNavigate";
import Footer from "../../../components/Footer/Footer";

const WebMobileApp = ({
    language
}) => {
    const {
        t,
        i18n,
        isLangRTL
    } = useStateContext();

    return (
        <>
            <div className="relative w-[100vw] h-full text-base">
                {/* HALF CIRCLE */}
                <div
                    className={`${!isLangRTL(i18n.language) ? "left-0 rounded-r-full" : "right-0 rounded-l-full"
                        } fixed top-5 primary-bg w-[150px] h-[300px] md:w-[200px] md:h-[400px] lg:w-[250px] lg:h-[500px]`}
                    style={{
                        zIndex: 0
                    }}
                ></div>
                <div className="padding-container relative w-full h-full py-5 my-5" style={{ zIndex: 1 }}>
                    {/* LOGO */}
                    {/* <div className="w-full flex items-center justify-center pb-5">
                        <img src={logo} alt="DoDeal Properties" className="w-[70px]" />
                    </div> */}
                    {/* LANGUAGE */}
                    {/* <LanguageNavigate
                        redirect={language === "English" ? "/web-mobile-apps/ar/" : "/web-mobile-apps/"}
                    /> */}

                    <div className="h-[50px]"></div>
                    {/* HEADING */}
                    <div className="w-full py-2 mb-5 pb-5 flex items-center justify-start">
                        <div className="font-bold uppercase text-3xl md:text-4xl lg:text-5xl xl:text-6xl mt-5 text-start w-[350px] md:w-[550px] lg:w-[750px] xl:w-[950px]">
                            {/* The Future of Web & Mobile, Today */}
                            {t("techCampaignTitle")}
                        </div>
                    </div>
                    <div className="my-5 py-5">
                        {/* From concept to launch, we deliver user-friendly websites and apps that make life simpler. */}
                        {t("techCampaignSubtitle")}
                    </div>
                    {/* FORM */}
                    <div className="my-5 py-5">
                        <WebMobileAppForm
                            language={language}
                        />
                    </div>
                </div>
                {/* <Footer /> */}
            </div>
        </>
    );
}

export default WebMobileApp;
